import { CobaltButton } from '@cae/cobalt-react/components/button';
import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import { CobaltIconFilterOutline } from '@cae/cobalt-react/icons/outline/CobaltIconFilterOutline';
import { CobaltIconFilterSolid } from '@cae/cobalt-react/icons/solid/CobaltIconFilterSolid';
import { useInstructorsFilter } from '@features/instructors/contexts/filter/useInstructorsFilter';
import * as React from 'react';

import type { InstructorsFilterButtonProps } from './InstructorsFilterButton.types';

const InstructorsFilterButton = React.memo(
  ({
    onFiltersOpen,
    disabled = false,
  }: Readonly<InstructorsFilterButtonProps>): React.ReactElement => {
    const isMobileOrTablet = useMediaQuery(MediaQuery.MobileAndTablet);
    const { filters } = useInstructorsFilter();

    const totalAppliedFilters = React.useMemo(
      () =>
        filters.disciplines.length +
        filters.locations.length +
        filters.programs.length,
      [filters]
    );

    const ariaLabel = React.useMemo(
      (): string =>
        totalAppliedFilters > 0
          ? `Filters (${totalAppliedFilters} applied)`
          : 'Filters',
      [totalAppliedFilters]
    );

    return (
      <CobaltButton
        variant="ghost"
        disabled={disabled}
        data-testid="instructors-filter-button"
        onClick={onFiltersOpen}
        aria-label={ariaLabel}
      >
        {totalAppliedFilters === 0 ? (
          <CobaltIconFilterOutline />
        ) : (
          <CobaltIconFilterSolid />
        )}
        {!isMobileOrTablet
          ? `Filters${totalAppliedFilters > 0 ? ` (${totalAppliedFilters})` : ''}`
          : null}
      </CobaltButton>
    );
  }
);

InstructorsFilterButton.displayName = 'InstructorsFilterButton';

export { InstructorsFilterButton };
